const TYPES = ({

  // list
  loadingFormSearch: 'LOADING_SEARCH_SETTINGS_ORIGIN_FORM_TOGGLE',
  searchSuccess: 'SEARCH_SETTINGS_ORIGIN_SUCCESS',
  searchError: 'SEARCH_SETTINGS_ORIGIN_LIST_ERROR',

  // form create
  updateItemListingManagerSuccess: 'MANAGER_SETTINGS_ORIGIN_SUCCESS_UPDATE_LISTING',
  insertItemListingManagerSuccess: 'MANAGER_SETTINGS_ORIGIN_SUCCESS_INSERT_LISTING',
  deleteItemListingManagerSuccess: 'MANAGER_SETTINGS_ORIGIN_SUCCESS_DELETE_LISTING',

  // form search
  setDefaultPage: 'SET_SEARCH_SETTINGS_ORIGIN_DEFAULT_PAGE',
});

export default TYPES;
